<template>
  <div v-loading="loading" class="mp-search">
    <div class="mp-panel">
      <div class="mp-crumb">
        <span class="mp-crumb__link" @click="goto('market')">活动市场</span>
        ›
        <span class="mp-crumb__cur">“{{ searchKeyword }}” 的搜索结果</span>
      </div>
      <MarketTemplateGrid :ids="resultIds" :columns="5" @preview="openPreview" @use="openUse" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import { useMarketPortal } from '../useMarketPortal'
import { useMarketPortalStore } from '../useMarketPortalStore'
import MarketTemplateGrid from '../components/MarketTemplateGrid.vue'

defineOptions({ name: 'MarketSearchPage' })

const emit = defineEmits<{
  preview: [id: number]
  use: [id: number]
}>()

const { searchKeyword, goto } = useMarketPortal()
const { loading, searchTemplates } = useMarketPortalStore()

const resultIds = ref<number[]>([])

watch(
  searchKeyword,
  async (kw) => {
    if (!kw.trim()) {
      resultIds.value = []
      return
    }
    resultIds.value = await searchTemplates(kw.trim(), 20)
  },
  { immediate: true }
)

const openPreview = (id: number) => emit('preview', id)
const openUse = (id: number) => emit('use', id)
</script>

<style lang="scss" scoped>
.mp-search {
  width: 100%;
}

.mp-panel {
  background: #fff;
  border-radius: 8px;
  padding: 12px 16px;
}

.mp-crumb {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #909399;
  font-size: 13px;
  margin-bottom: 14px;

  &__link {
    cursor: pointer;

    &:hover {
      color: #2b6de8;
    }
  }

  &__cur {
    color: #303133;
    font-weight: 600;
  }
}
</style>
